import { render, staticRenderFns } from "./AnuncioForm.vue?vue&type=template&id=28bec9c5&scoped=true&"
import script from "./AnuncioForm.vue?vue&type=script&lang=js&"
export * from "./AnuncioForm.vue?vue&type=script&lang=js&"
import style0 from "./AnuncioForm.vue?vue&type=style&index=0&id=28bec9c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bec9c5",
  null
  
)

export default component.exports